export default "__VITE_ASSET__LL4KB09B__"